
const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
const arabicDigits = "٠١٢٣٤٥٦٧٨٩";
const englishDigits = "0123456789";

const persianMap = persianDigits.split("").reduce((acc, digit, i) => {
  acc[digit] = englishDigits[i];
  return acc;
}, {} as Record<string, string>);

const arabicMap = arabicDigits.split("").reduce((acc, digit, i) => {
  acc[digit] = englishDigits[i];
  return acc;
}, {} as Record<string, string>);

const englishToPersianMap = englishDigits.split("").reduce((acc, digit, i) => {
    acc[digit] = persianDigits[i];
    return acc;
}, {} as Record<string, string>);


export const toEnglishDigits = (str: string): string => {
  if (str === null || str === undefined) return "";
  return String(str)
    .replace(/[۰-۹]/g, (d) => persianMap[d])
    .replace(/[٠-٩]/g, (d) => arabicMap[d]);
};

export const toPersianDigits = (str: string): string => {
    if (str === null || str === undefined) return "";
    return String(str).replace(/[0-9]/g, (d) => englishToPersianMap[d]);
};
